module.exports = __webpack_public_path__ + "media/images/mypage/icon/green/ico_office-db79eda36ac765c9f157ac3864b6bdad.svg";